import React, { FC, useMemo } from 'react';
import { Column } from 'react-table';
import Table from '../../components/Table';
import { DeviceOverviewData } from '../../api/mobilbase/models';
import AlignedCell from '../../components/layout//AlignedCell';
import AlignedHeader from '../layout/AlignedHeader';

interface DeviceOverviewTableProps {
  data: DeviceOverviewData[];
  isPending: boolean;
  handleOpenDialog: (element: DeviceOverviewData) => void;
  setRun: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeviceOverviewTable: FC<DeviceOverviewTableProps> = ({ data, isPending, handleOpenDialog, setRun }) => {
  const columns: Column<DeviceOverviewData>[] = useMemo(
    () => [
      { Header: 'Automat nummer', id: "0", accessor: 'deviceID' },
      { Header: 'Automat navn', id: "1", accessor: 'name' },
      { Header: '220V', id: "2", accessor: 'power'},
      { Header: 'Dør', id: "3", accessor: 'door' },
      { Header: 'I drift', id: "4", accessor: 'inUse' },
      { Header: 'Printer', id: "5", accessor: 'printer' },
      { Header: 'Kort', id: "6", accessor: 'card' },
      { Header: 'Mønt', id: "7", accessor: 'coin' },
      { Header: 'Papirstatus', id: "8", accessor: 'paperStatus' },
      { Header: 'Display', id: "9", accessor: 'display' },
      { Header: 'Kort trans.', id: "10", accessor: 'lastCard',
        sortType: (rowA, rowB) => {
          if (rowA.values.lastCard && rowB.values.lastCard) {
            const a = rowA.values.lastCard.split(/-|:| /);
            const b = rowB.values.lastCard.split(/-|:| /);
            return ((a[2] + a[1] + a[0] + a[3] + a[4] + a[5]) < (b[2] + b[1] + b[0] + b[3] + b[4] + b[5])) ? -1 : 1;
          } else {
            return -1;
          }
        }
      },
      { Header: 'Mønt trans.', id: "11", accessor: 'lastCoin',
        sortType: (rowA, rowB) => {
          if (rowA.values.lastCoin && rowB.values.lastCoin) {
            const a = rowA.values.lastCoin.split(/-|:| /);
            const b = rowB.values.lastCoin.split(/-|:| /);
            return ((a[2] + a[1] + a[0] + a[3] + a[4] + a[5]) < (b[2] + b[1] + b[0] + b[3] + b[4] + b[5])) ? -1 : 1;
          } else {
            return -1;
          }
        }
      },
      { Header:()=><AlignedHeader value='Møntboks' justify='flex-end' alignT='right'/> , id: "12", accessor: 'coinbox', Cell: ({ value }: { value: string }) => <AlignedCell value={value} /> },
      { Header:()=><AlignedHeader value='Printtæller' justify='flex-end' alignT='right'/> , id: "13", accessor: 'printerCount' , Cell: ({ value }: { value: string }) => <AlignedCell value={value} /> },
    ],
    []
  );

  function customCellStyle<T extends object>(columns: Column<T>[], index: number, value: any) {
    return {
      background: (
        (columns[index].accessor?.toString() === "power" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "door" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "inUse" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "printer" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "card" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "coin" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "display" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "paperStatus" && value === "Fejl")
      ) ? "rgba(255, 0, 0, 0.3)" : ""
    }
  }

  return (
    <Table<DeviceOverviewData>
      columns={columns}
      data={data}
      initialState={{ pageSize: 150 }}
      clickEvent={handleOpenDialog}
      update={() => { setRun(true); }}
      pending={isPending}
      text={""}
      customCellStyle={customCellStyle}
    />
  );
};

export default DeviceOverviewTable;